import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh/compare/cargowise-alternative")({
  beforeLoad: () => {
    throw redirect({ to: "/zh/compare/cargonova-vs-cargowise", replace: true });
  },
});
